import api from '@/lib/axios'

export interface Workspace {
  id: string
  name: string
  description?: string
  channels: Channel[]
}

export interface Channel {
  id: string
  name: string
  description?: string
  type: 'PUBLIC' | 'PRIVATE' | 'DIRECT' | 'GROUP'
  isArchived: boolean
  workspaceId: string
  unreadCount?: number
  lastMessage?: Message
  members?: ChannelMember[]
}

export interface ChannelMember {
  id: string
  userId: string
  role: 'OWNER' | 'ADMIN' | 'MEMBER'
  lastReadAt?: string
  user: { id: string; firstName: string; lastName: string; avatarUrl?: string }
}

export interface Message {
  id: string
  content: string
  channelId: string
  authorId: string
  author: { id: string; firstName: string; lastName: string; avatarUrl?: string }
  parentId?: string
  editedAt?: string
  deletedAt?: string
  isPinned?: boolean
  mentions?: { userId: string; user: { firstName: string; lastName: string } }[]
  reactions?: MessageReaction[]
  attachments?: { id: string; url: string; name: string; size: number }[]
  createdAt: string
}

export interface MessageReaction {
  emoji: string
  count: number
  hasReacted: boolean
}

export const chatApi = {
  // ── Workspaces ─────────────────────────────────────────────────────────────
  getWorkspaces: () =>
    api.get('/chat/workspaces').then(r => r.data.data),

  createWorkspace: (data: { name: string; description?: string }) =>
    api.post('/chat/workspaces', data).then(r => r.data.data),

  // ── Canaux ─────────────────────────────────────────────────────────────────
  getChannels: (workspaceId: string) =>
    api.get(`/chat/workspaces/${workspaceId}/channels`).then(r => r.data.data),

  createChannel: (workspaceId: string, data: { name: string; description?: string; type?: string }) =>
    api.post(`/chat/workspaces/${workspaceId}/channels`, data).then(r => r.data.data),

  getChannel: (channelId: string) =>
    api.get(`/chat/channels/${channelId}`).then(r => r.data.data),

  getOrCreateDirect: (userId: string, workspaceId: string) =>
    // FIX: route correcte = /workspaces/:workspaceId/channels/direct
    api.post(`/chat/workspaces/${workspaceId}/channels/direct`, { targetUserId: userId }).then(r => r.data.data),

  // ── Messages ───────────────────────────────────────────────────────────────
  getMessages: (channelId: string, params?: { before?: string; after?: string; limit?: number }) =>
    api.get(`/chat/channels/${channelId}/messages`, { params }).then(r => r.data.data),

  markRead: (channelId: string) =>
    api.patch(`/chat/channels/${channelId}/read`).then(r => r.data.data),

  // ── Membres ────────────────────────────────────────────────────────────────
  getMembers: (channelId: string) =>
    api.get(`/chat/channels/${channelId}/members`).then(r => r.data.data),

  addMember: (channelId: string, userId: string) =>
    // FIX: backend InviteMembersDto attend userIds (array), pas userId (string)
    api.post(`/chat/channels/${channelId}/members`, { userIds: [userId] }).then(r => r.data.data),

  // ── Messages avancés ───────────────────────────────────────────────────────
  pinMessage: (channelId: string, messageId: string) =>
    api.patch(`/chat/channels/${channelId}/messages/${messageId}/pin`).then(r => r.data.data),

  getPinnedMessages: (channelId: string) =>
    api.get(`/chat/channels/${channelId}/messages/pinned`).then(r => r.data.data),

  getUnreadMentions: () =>
    api.get('/chat/mentions/unread').then(r => r.data.data),
}
